/**
 * Grupos de endpoints por função/módulo SIAL (modal Grupos → «Por função»).
 * Cada grupo usa substrings do path (`endpoint`) ou do nome amigável.
 * Ao clicar, todos os endpoints correspondentes ainda não selecionados são incluídos.
 */
export default [
	{
		label: 'Saídas',
		patterns: [
			'/outputs', '/output-picking', '/output-unpick', '/output-conference',
			'print-stage-labels', 'print-labels', 'print-picklists', 'print-control',
			'print-ar', 'print-conference', 'print-balance-trace', 'pallets-overturn',
			'create-invoices', 'reverse-output', 'search-references', 'list-stage-labels',
			'list_output', 'volume-labels', 'checked-by', 'picked-by', 'manual-status-advance',
		],
	},
	{
		label: 'Pedidos de Saída',
		patterns: [
			'/output-orders', 'approve-orders', 'create-pending-order', 'expected-delivery',
			'export-list-csv', 'espelho-pedido', 'order-upload', 'shortage-link',
		],
	},
	{
		label: 'Entradas',
		patterns: [
			'/inputs', 'inputs-complete', 'inputs-coletor', 'putaway', 'inventory-input',
			'input-rastro', 'input-documents', 'verified-at',
		],
	},
	{
		label: 'Pedidos de Entrada',
		patterns: ['/input-orders', '/receipt-types', 'order-upload'],
	},
	{
		label: 'Estoques',
		patterns: [
			'/stocks', '/stock-management', 'stock-packaging', 'sku-no-output',
			'print-balance-blocks', 'balance-blocks', 'resolve-gtin', 'storage-class',
		],
	},
	{
		label: 'Movimentações',
		patterns: ['/transactions', '/movements', 'movement-kind', 'block-types'],
	},
	{
		label: 'Catálogo',
		patterns: [
			'/products', '/packagings', '/product-packagings', '/categories',
			'/manufacturers', '/units', '/classes', '/programs',
		],
	},
	{
		label: 'Armazenamento',
		patterns: [
			'/warehouses', '/locations', '/lots', '/inventories', '/inventory-sessions',
			'/replenishments', '/replenishment-rules', '/replenishment-orders', '/devices',
			'print-labels', 'locations-catalog', 'location-move',
		],
	},
	{
		label: 'Comercial',
		patterns: [
			'/customers', '/customer-routes', '/customer-prices', '/customer-delivery',
			'/payment-terms', '/price-lists', '/cfops', 'count-report', 'print-report',
		],
	},
	{
		label: 'Faturamento',
		patterns: [
			'/invoices', '/invoice-lots', '/nfe-emission', 'inutilizar', 'create-lots',
			'create-archive', 'update-xml', 'print-iqvia',
		],
	},
	{
		label: 'Organização',
		patterns: ['/suppliers', '/carriers'],
	},
	{
		label: 'BI e relatórios',
		patterns: [
			'/reports/', '/companies/<company_id>/reports', 'kardex', 'stock-complete',
			'stock-blocks-descriptive', 'output-lines', 'audit-report', 'products-general',
			'product-packagings', 'bi-', '/bi/',
		],
	},
	{
		label: 'Integrações',
		patterns: [
			'/integration-events', '/techhub', '/gsnet', '/amil/', 'protheus', 'iqvia',
			'closeup', 'vendatus', 'entity-alerts', 'forced-pull', 'forced-flush',
		],
	},
	{
		label: 'Sistema',
		patterns: [
			'/groups', '/users', '/companies', '/endpoints', '/states', '/cities',
			'/logs', '/version', '/import-center', 'audit-pending', 'audit-logs',
			'import-center', 'integration-events', '/auth',
		],
	},
];

/**
 * @param {{ endpoint?: string, name?: string }} ep
 * @param {{ patterns: string[] }} functionGroup
 */
export function endpointMatchesFunctionGroup(ep, functionGroup)
{
	const path = String(ep?.endpoint || '').toLowerCase();
	const name = String(ep?.name || '').toLowerCase();
	return functionGroup.patterns.some((pat) =>
	{
		const p = String(pat).toLowerCase();
		return path.includes(p) || name.includes(p.replace(/\//g, ' ').trim());
	});
}
